import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const PIXEL_ID = '877006431979007';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel - simplified version
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    return () => {
      // Cleanup on unmount
      document.head.removeChild(script);
    };
  }, []);
  return <LandingPage data-id="element-0" />;
}